export const td = (t, key, options) => String(t(key, options));
